<template>
  <div>
    <div class="search-all-box">
      <a-form-model layout="inline" ref="ruleForm" :model="form">

        <a-form-model-item prop="user_name">
          <a-input v-model="form.username" class="search-input" placeholder="请输入账号"></a-input>
        </a-form-model-item>
        <a-form-model-item prop="name">
          <a-input v-model="form.name" class="search-input" placeholder="请输入姓名"></a-input>
        </a-form-model-item>
        <a-form-model-item prop="mobile">
          <a-input v-model="form.mobile" class="search-input" placeholder="请输入手机号"></a-input>
        </a-form-model-item>
        <a-form-model-item>
          <a-button class="search-btn" type="primary" @click="onSearch()">搜索</a-button>
          <a-button class="reset-btn" @click="resetForm()">重置</a-button>
        </a-form-model-item>
      </a-form-model>
      <div class="right-option-box">
        <a-button class="option-btn" type="primary" @click="exportFile">导出附件</a-button>
      </div>
    </div>
    <div class="table-all-box">
      <a-table :columns="columns" :data-source="tableData" rowKey="id" :bordered="false" size="small" :pagination="false">

      </a-table>

      <a-pagination class="school-pagination" v-model="page" :total="totalNum" @change="pageChange" show-less-items />
    </div>
  </div>
</template>

<script>
// import CommonModal from "../../../../components/CommonModal"
import { mapActions } from "vuex";
import services from '../../../../assets/js/services';
export default {
  name: 'hsjrSubmited',
  // components: {
  //   CommonModal
  // },
  data() {
    return {
      school_code: localStorage.getItem("schoolCode"),
      btnTxt: '< 返回实践班级',
      page: 1,
      size: 10,
      totalNum: 0,
      tableData: [],
      form: {
        complete_type: "", //完成形式
        name: "", //故事名字
        username: "", //提交人
        mobile: "", //基地名称

      },
      showTableSelection: false, // 多选框是否显示
      selectedRowKeys: [], // 选中行key
      columns: [
        {
          title: "账号",
          dataIndex: "username",
        },
        {
          title: "姓名",
          dataIndex: "name",
        },
        {
          title: "手机号",
          dataIndex: "mobile",
        },
      ], // 从学生库选择的行key
      showDeleteModal: false,
      showChooseModal: false,
      class_id: '', //当前班级id
      studentId: '', // 单选删除时选中的学生id
    };
  },
  computed: {
    rowSelection() {
      let that = this
      const { selectedRowKeys, showTableSelection } = that;
      return showTableSelection ? {
        selectedRowKeys,
        onChange: that.onSelectChange
      } : null
    }
  },
  mounted() {
    this.class_id = this.$route.query.cid
    this.getTableList()
  },
  methods: {
    ...mapActions(["gethsjrClassReviewUndo",]),
    getTableList() {
      let params = {
        page: this.page,
        size: this.size,
        class_id: this.class_id,
        name: this.form.name,
        username: this.form.username,
        mobile: this.form.mobile,
        export_flag: 0,
      };

      this.gethsjrClassReviewUndo(params).then((res) => {
        if (res.code == "0000" && res.data) {
          this.tableData = res.data.items;
          this.totalNum = res.data.total;
          // console.log(res.data)
        }
      });
    },
    onSearch() {
      this.page = 1;
      this.total = 0;
      this.getTableList();
    },
    pageChange(val) {
      this.page = val;
      this.total = 0;
      this.getTableList();
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
      this.onSearch()
    },
    handleModalVisible(key, val) {
      this[key] = val
    },

    onSelectChange(rows) {
      this.selectedRowKeys = rows
    },
    // 表格中 删除按钮 点击事件
    deleteStudentModal(item) {
      this.studentId = item.id
      this.delType = 1
      this.handleModalVisible('showDeleteModal', true)
    },
    // 班级添加和删除方法
    studentDelete(params) {
      this.delhsjrStudent(params).then(res => {
        if (res.code == "0000") {
          this.studentId = ''
          this.cancelSelection()
          this.$message.success(`删除成功`)
          this.handleModalVisible('showDeleteModal', false)
          this.resetForm()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 批量删除 按钮点击事件
    manySelection() {
      this.showTableSelection = true
    },
    // 取消批量删除
    cancelSelection() {
      this.showTableSelection = false
      this.selectedRowKeys = []
    },
    // 确认批量删除事件
    selectedDelete() {
      if (this.selectedRowKeys.length > 0) {
        this.delType = 2
        this.handleModalVisible("showDeleteModal", true)
      } else {
        this.$message.error('请选择要删除的学生')
      }
    },
    exportFile() {
      let params = {
        page: this.page,
        size: this.size,
        class_id: this.class_id,
        name: this.form.name,
        user_name: this.form.user_name,
        mobile: this.form.mobile,
        export_flag: 1,
      };
      window.open(`${services.HOST}/api/school/train/venue/story/undo?page=1&size=100&class_id=${params.class_id}&export_flag=1`)
    }

  },
};
</script>

<style lang="less" scoped>
.back-class-btn {
  padding: 0 16px;
  height: 32px;
  background: #b84b3c;
  border-radius: 16px;
  font-weight: bold;
  font-size: 14px;
  color: #ffffff;
  text-align: center;
  margin-bottom: 15px;
  line-height: 32px;
  &:hover {
    background: #a82822;
  }
}
.delete-modal {
  font-weight: bold;
  font-size: 16px;
  color: #373536;
  text-align: center;
}
.choose-modal {
  padding-top: 20px;
}
</style>